import $ from 'jquery';
import 'select2'

$(document).ready(function() {

    var $selectBox = $("#instructor");
    $selectBox.select2({
	placeholder: "Select the Instructor"
    });
    
    $selectBox.on('select2:select', function (e) {
        var email = $(e.params.data.element).data("email");
	var $emailField = $selectBox.parent().parent().find('[type="email"]').first();
	var $hiddenEmailField = $selectBox.parent().parent().find('[type="hidden"]').first();
	if (email){
	    $emailField.val(email).prop("disabled", true);
	    $hiddenEmailField.val(email);
	}
	else {
	    $emailField.val("").prop("disabled", false);
	    $hiddenEmailField.val("");
	}
    });

});
